import "./header.css";
import { useState } from "react";
// import logo from "../../assets/images/others/logo.png";
// import logoHead from "../../assets/images/others/logo.png";
import { Menu, Close, ChevronRight, ChevronLeft, Instagram, Twitter } from '@material-ui/icons';
import discordImg from "assets/images/others/discord.svg"
import { Fade } from "react-reveal";
// import posterLogo from "assets/videos/poster_logo2.PNG"
// import logoVideo from "assets/videos/logo2.mp4"
import logoGif from "assets/videos/logo2.gif"

const Header = () => {
    const [sideBar, setSideBar] = useState(false);

    // go to the section
    const scrollTo_Section = (sec_id) => {
        let element = document.getElementById(sec_id);
        const yOffset = -127;
        if (element) {
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };
    return (
        <Fade top>
            <header className="web-header">
                <div className="row header-container">
                    <div className="header-logo-area row">
                        <img
                            onClick={() => scrollTo_Section('home')}
                            className="header-main-logo"
                            loading="lazy"
                            src={logoGif}
                            alt="" />
                            {/* <h4 className="header-text-logo">META MASKS NFT</h4> */}
                            {/* <video loop muted autoPlay poster={posterLogo}>
                                <source src={logoVideo}/>
                            </video> */}
                    </div>
                    <div className="header-right-area">

                        <a href="https://discord.gg/metamasksnft" target="_blank" rel="noopener noreferrer" className="header-social-btn row">
                            <img src={discordImg} alt="" />
                        </a>
                        <a href="https://www.instagram.com/metamasksnft/" target="_blank" rel="noopener noreferrer" className="header-social-btn row">
                            <Instagram/>
                        </a>
                        <a href="https://mobile.twitter.com/metamasksnft" target="_blank" rel="noopener noreferrer" className="header-social-btn row">
                            <Twitter/>
                        </a>
                        <a href="https://discord.gg/metamasksnft" target="_blank" rel="noopener noreferrer" className="header-join-btn row">
                            Join Discord
                            <img src={discordImg} alt="" />
                        </a>
                        <div className="menu-btn">
                            {sideBar ?
                                <Close onClick={() => setSideBar(false)} className="menu-icon" />
                                : <Menu onClick={() => setSideBar(true)} className="menu-icon" />
                            }
                        </div>
                    </div>
                </div>

                {sideBar && <div onClick={() => setSideBar(false)} className="backdrop-sidebar"></div>}
                <nav className={`side-bar-wrapper ${sideBar ? 'opened-sidebar' : ''}`}>
                    <div className="side-logo">
                        <img loading="lazy" src={logoGif} alt="" />
                        {/* <video loop muted autoPlay poster={posterLogo}>
                                <source src={logoVideo}/>
                            </video> */}
                    </div>
                    <ul>
                        <li><button className="header-links" onClick={() => { setSideBar(false); scrollTo_Section('about'); }}>About MetaMask</button></li>
                        {/* <li><button className="header-links" onClick={() => { setSideBar(false); scrollTo_Section('story') }}>Elite Leopards</button></li> */}
                        <li><button className="header-links" onClick={() => { setSideBar(false); scrollTo_Section('nft') }}>Collection</button></li>
                        <li><button className="header-links" onClick={() => { setSideBar(false); scrollTo_Section('roadmap') }}>Roadmap</button></li>
                        {/* <li><button className="header-links" onClick={() => { setSideBar(false); scrollTo_Section('charity') }}>Charity</button></li> */}
                        {/* <li><button className="header-links" onClick={() => { setSideBar(false); scrollTo_Section('token') }}>Token</button></li> */}
                        <li><button className="header-links" onClick={() => { setSideBar(false); scrollTo_Section('faq') }}>FAQ</button></li>
                        <li><button className="header-links" onClick={() => { setSideBar(false); scrollTo_Section('team') }}>Team</button></li>
                    </ul>
                    <div className="social sidebar-socials row">
                        <div className="link">
                            <a href="https://discord.gg/metamasksnft" target="_blank" rel="noopener noreferrer" className="discord row">.</a>
                        </div>
                        <div className="link">
                            <a href="https://www.instagram.com/metamasksnft/" target="_blank" rel="noopener noreferrer" className="insta row">.</a>
                        </div>
                        <div className="link">
                            <a href="https://mobile.twitter.com/metamasksnft" target="_blank" rel="noopener noreferrer" className="twitter row">.</a>
                        </div>
                    </div>
                    <div className="sidebar-close-btn" onClick={() => setSideBar(false)}>
                        <ChevronRight className="chev-icon" />
                    </div>
                </nav>
            </header>
            <div className="header-spacer"></div>
            <div className="sidebar-open-btn" onClick={() => setSideBar(true)}>
                <Menu className="chev-icon open_chev" />
            </div>
        </Fade>
    )
}

export default Header
